import {
  BRANCH_SELECTED,
  FETCH_BRANCH_STOCK_FAILURE,
  FETCH_BRANCH_STOCK_STARTED,
  FETCH_BRANCH_STOCK_SUCCESS,
  FETCH_CLEARANCE_PRICE_FAILED,
  FETCH_CLEARANCE_PRICE_STARTED,
  FETCH_CLEARANCE_PRICE_SUCCESS,
  FETCH_PRICES_FAILURE,
  FETCH_PRICES_STARTED,
  FETCH_PRICES_SUCCESS,
  FETCH_STOCK_FAILURE,
  FETCH_STOCK_STARTED,
  FETCH_STOCK_SUCCESS,
  FETCH_SUBURB,
  GST_TYPE_TOGGLED,
  POST_CODE_UPDATED,
  PRICE_DETAILS_UPDATED,
  PRICE_TYPE_TOGGLED,
  QUANTITY_DECREMENTED,
  QUANTITY_INCREMENTED,
  QUANTITY_UPDATED,
  STOCK_DETAILS_UPDATED,
  UNIT_OF_MEASURE_UPDATED,
  WISHLIST_TOGGLED,
} from "./PriceBlockActionTypes";
import {GST_EXCLUSIVE, GST_FREE, GST_INCLUSIVE} from "./GstTypes";
import {CMP} from "./PriceTypes";
import isValidPrice from "../../utils/isValidPrice";
import isValidQuantity, {INVALID_QUANTITY_ERROR_MESSAGE} from "../../utils/isValidQuantity";
import isNumber from "../../utils/isNumber";

const getPriceOrNull = (priceList, priceType, unitOfMeasure, gstType) => {
  const price = (
    priceList &&
    priceList[priceType] &&
    priceList[priceType][unitOfMeasure] &&
    priceList[priceType][unitOfMeasure][gstType]
  );
  return price >=0 ? price : null;
};

const isAddToCartEnabled = (price, quantity) => {
  return isValidPrice(price) && isValidQuantity(quantity);
};

const decrementQuantity = (quantity) => {
  if (isNumber(quantity)) {
    return quantity - 1;
  }
  return quantity;
};

const incrementQuantity = (quantity) => {
  if (isNumber(quantity)) {
    return quantity + 1;
  }
  return quantity;
};

const invalidQuantityErrorOrNull = (quantity) => {
  return isValidQuantity(quantity) ? null : INVALID_QUANTITY_ERROR_MESSAGE;
};

const isValidFlagOrFalse = (flag) => {
  return flag ? flag : false;
};

function getClearanceNewPack1IncGSTPrice( clearancePrice){

  return clearancePrice
    && clearancePrice.newPrice
    && clearancePrice.newPrice.pack1
    && clearancePrice.newPrice.pack1.priceIncGST || 0;
}

function getClearanceOldPack1IncGSTPrice(clearancePrice){
  return clearancePrice
    && clearancePrice.oldPrice
    && clearancePrice.oldPrice.pack1
    && clearancePrice.oldPrice.pack1.priceIncGST || 0;
}

const getClearancePrice = (clearancePrice, productPrice) => {
      const clearanceNewPrice = getClearanceNewPack1IncGSTPrice(clearancePrice);
      const clearanceOldPrice = getClearanceOldPack1IncGSTPrice(clearancePrice);
      if (productPrice === clearanceNewPrice && productPrice < clearanceOldPrice)
        return clearanceOldPrice;
      else
        return null;

}

export const reducer = (state, action) => {
  switch(action.type) {
    case POST_CODE_UPDATED:
      if (state.isPostCodeUpdateRequired && action.payload) {
        return {...state, isPostCodeUpdateRequired: false};
      }

      return state;

    case FETCH_PRICES_STARTED:
      return {...state, isPriceListLoading: true};

    case FETCH_PRICES_SUCCESS:
      return {...state, isPriceListLoading: false, priceList: action.payload};

    case FETCH_PRICES_FAILURE:
      return {...state, isPriceListLoading: false, priceListError: action.payload};

    case FETCH_CLEARANCE_PRICE_STARTED:
      return {...state, isClearancePriceLoading: true};

    case FETCH_CLEARANCE_PRICE_SUCCESS:
      return {...state, isClearancePriceLoading: false,
        oldGstInclusivePrice: getClearancePrice(action.payload.clearancePrice, action.payload.gstIncludePrice)};

    case FETCH_CLEARANCE_PRICE_FAILED:
      return {...state, isClearancePriceLoading: false, error:true};

    case UNIT_OF_MEASURE_UPDATED:
      return {...state, selectedUnitOfMeasure: action.payload};

    case GST_TYPE_TOGGLED:
      if (state.showGstToggle) {
        const gstType = state.gstType === GST_INCLUSIVE ? GST_EXCLUSIVE : GST_INCLUSIVE;
        return {...state, gstType};
      }

      return state;

    case PRICE_TYPE_TOGGLED:
      return {...state, priceType: action.payload};

    case PRICE_DETAILS_UPDATED: {
      const { priceList, priceType, gstType, selectedUnitOfMeasure, quantity } = state;

      const gstTypeForPrice = gstType === GST_FREE ? GST_INCLUSIVE : gstType;

      const price = getPriceOrNull(priceList, priceType, selectedUnitOfMeasure, gstTypeForPrice);
      const gstInclusivePrice = getPriceOrNull(priceList, priceType, selectedUnitOfMeasure, GST_INCLUSIVE);
      const cmpGstInclusivePrice = getPriceOrNull(priceList, CMP, selectedUnitOfMeasure, GST_INCLUSIVE);

      const canAddToCart = isAddToCartEnabled(gstInclusivePrice || cmpGstInclusivePrice, quantity);

      return {
        ...state,
        price,
        gstInclusivePrice,
        cmpGstInclusivePrice,
        canAddToCart
      };
    }

    case QUANTITY_DECREMENTED: {
      const { quantity } = state;

      const newQuantity = decrementQuantity(quantity);

      return {...state, quantity: newQuantity, quantityError: invalidQuantityErrorOrNull(newQuantity) }
    }

    case QUANTITY_INCREMENTED: {
      const { quantity } = state;

      const newQuantity = incrementQuantity(quantity);

      return {...state, quantity: newQuantity, quantityError: invalidQuantityErrorOrNull(newQuantity) }
    }

    case QUANTITY_UPDATED: {
      const newQuantity = isNumber(action.payload) ? Number(action.payload) : action.payload;

      return {...state, quantity: newQuantity, quantityError: invalidQuantityErrorOrNull(newQuantity) }
    }

    case WISHLIST_TOGGLED: {

      return {...state, isInWishlist: action.payload};
    }

    case FETCH_STOCK_STARTED:
      return {...state, isStockAvailabilityLoading: true};

    case FETCH_STOCK_SUCCESS:
      return {...state, isStockAvailabilityLoading: false, stockAvailabilityList: action.payload.productStockStatus, showBranchSelector: isValidFlagOrFalse(action.payload.showBranchSelector), stockError: null};

    case FETCH_STOCK_FAILURE:
      return {...state, isStockAvailabilityLoading: false, stockError: action.payload};

    case STOCK_DETAILS_UPDATED: {
      const {stockAvailabilityList, selectedUnitOfMeasure} = state;
      return {...state, stockAvailability: stockAvailabilityList[selectedUnitOfMeasure]};
    }

    case FETCH_BRANCH_STOCK_STARTED:
      return {...state, isStockAvailabilityBranchesLoading: true};

    case FETCH_BRANCH_STOCK_SUCCESS:
      return {...state, isStockAvailabilityBranchesLoading: false, stockAvailabilityBranchesList: action.payload, stockBranchesError: null};

    case FETCH_BRANCH_STOCK_FAILURE:
      return {...state, isStockAvailabilityBranchesLoading: false, stockBranchesError: action.payload};

    case FETCH_SUBURB:
      return {...state, suburbsList: action.payload};

    case BRANCH_SELECTED:
      return {...state, branchId: action.payload.branchId, branchName: action.payload.branchName};

    default:
      throw new Error(`Action type ${action.type} not implemented in PriceBlock reducer`);
  }
};

export const createAction = (type, payload) => ({ type, payload });

export default {
  reducer,
  createAction
};
